export enum RewardsOptionsSize {
  Small = 'Small - S',
  Medium = 'Medium - M',
  Large = 'Large - L',
  XL = 'Extra Large - XL',
  '2XL' = 'Extra Extra Large - 2XL',
  '3XL' = 'Extra Extra Extra Large - 3XL',
}
